import { createApplication } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { provideHttpClient } from '@angular/common/http';
import { PricingAppComponent } from './app/pricing/components/pricing-app/pricing-app.component';
import { PRICING_API_BASE_URL } from './app/pricing/tokens';
import { environment } from './environments/environment';

// Create Angular application with providers
createApplication({
  providers: [
    provideHttpClient(),
    { provide: PRICING_API_BASE_URL, useValue: environment.pricingApiBaseUrl }
  ]
})
.then(app => {
  // Create custom element from standalone component
  const pricingElement = createCustomElement(PricingAppComponent, {
    injector: app.injector
  });
  
  // Register the custom element with the browser
  customElements.define('pricing-app', pricingElement);
  
  console.log('✅ Pricing web component registered successfully');
})
.catch((err: Error) => {
  console.error('❌ Failed to bootstrap pricing element:', err);
});
